import { action } from 'typesafe-actions'
import { GuideTypes } from './types'

export const changeRecentView = (payload: string) => action(GuideTypes.CHANGE_RECENT_VIEW, payload)

export const changeRecentPath = (payload: string) => action(GuideTypes.CHANGE_RECENT_PATH, payload)
